import React, { useEffect, useState } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { bool } from 'prop-types';
import DesktopHeader from './DesktopHeader';
import MobileHeader from './MobileHeader';

export const isTopCheck = (isTop, updateIsTop) => {
    const isScrollYZero = window.scrollY === 0;

    if (isScrollYZero !== isTop) {
        updateIsTop(isScrollYZero);
    }
};

const Header = ({ hideNav }) => {
    const { header, banner } = useStaticQuery(graphql`
        {
            banner: datoCmsSiteBanner {
                showBanner
                backgroundPrimaryColour {
                    hex
                }
                image {
                    gatsbyImageData(
                        width: 50
                        layout: FIXED
                        imgixParams: { auto: "compress" }
                    )
                }
                structuredContent {
                    value
                }
                textColour {
                    hex
                }
                showButton
                buttonText
                buttonLink
                desktopButtonLink
            }
            header: datoCmsHeader {
                logo {
                    alt
                    gatsbyImageData(layout: CONSTRAINED)
                }
                desktopRightSection {
                    ...buttonFields
                }
                mobileBottomSection {
                    ...appsFlyerButtonFields
                    ...buttonFields
                    ... on DatoCmsImage {
                        __typename
                        id: originalId
                        image {
                            gatsbyImageData(
                                width: 350
                                layout: CONSTRAINED
                                imgixParams: { auto: "compress" }
                            )
                        }
                        maxWidth
                        link
                        whiteBackground
                        hideOnDesktop
                        hideOnMobile
                    }
                }
                menuItems {
                    ... on DatoCmsHeaderMenuItem {
                        __typename
                        id
                        title
                        url
                        submenu {
                            ... on DatoCmsSubmenuLink {
                                __typename
                                id
                                text
                                link
                            }
                        }
                    }
                }
            }
        }
    `);

    const [isTop, updateIsTop] = useState(true);

    useEffect(() => {
        /* istanbul ignore next */
        if (window.location.href.includes('#') && isTop) {
            updateIsTop(false);
        }
    }, []);

    /* istanbul ignore next */
    const isTopHandler = () => {
        isTopCheck(isTop, updateIsTop);
    };

    useEffect(() => {
        window.addEventListener('scroll', isTopHandler);
        return () => {
            window.removeEventListener('scroll', isTopHandler);
        };
    }, [isTop]);

    const { logo, ...rest } = header;

    const headerProps = {
        ...rest,
        isTop,
        hideNav
    };

    return (
        <header>
            <MobileHeader {...headerProps} logo={logo} banner={banner} />
            <DesktopHeader {...headerProps} logo={logo} banner={banner} />
        </header>
    );
};

Header.propTypes = {
    hideNav: bool
};

Header.defaultProps = {
    hideNav: false
};

export default Header;
